import { __assign } from "tslib";
// DS: I11
import React from 'react';
import IconWrap from '../../IconWrap';
var FavStarFill = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", d: "M6.435 1.493L4.817 4.244l-3.6.488a1 1 0 00-.813.672L.052 6.447a1 1 0 00.275 1.06L2.87 9.818l-.594 3.248a1 1 0 00.429 1.012l1.073.716a1 1 0 00.996.065l3.192-1.568 3.258 1.583a1 1 0 00.999-.072l1.04-.706a1 1 0 00.42-1.014l-.62-3.264 2.534-2.304a1 1 0 00.27-1.074l-.364-1.027a1 1 0 00-.808-.658l-3.61-.49-1.621-2.77A1 1 0 008.601 1H7.297a1 1 0 00-.862.493z" })))); };
FavStarFill.displayName = 'FavStarFill';
export default FavStarFill;
//# sourceMappingURL=FavStarFill.js.map